

import React, { useState } from 'react';
import '../css/entrainement.css'
export const Exerciceformscriptgoogle = () => {
    const scriptURL = 'https://script.google.com/macros/s/AKfycbwiWjhJnosfzZGfOgeTIf0ngcQALFnZXLzkkeAZWsqMOfc00hKA3oKy6EiQwBaZ_4cB3A/exec'
                 

    return (
        <>
            <div id="articleContent" className="entrainement">
                <form name="submit-to-google-sheet" className="formCreateNew" onSubmit={(event) => {
                    event.preventDefault();
                   const form = document.forms['submit-to-google-sheet']
                    fetch(scriptURL, { method: 'POST', body: new FormData(form) })
                        .then(response => {
                            if (response.status !== 200) {
                            } else {
                            }
                            return
                        })
                        .catch(error => {
                            return
                        })
                }}>
                    <div>
                        <label id="url">URL</label>
                        <input type="text" name="url" value="http://malikaleroy.fr/" />
                        <label id="entreprise">entreprise</label>
                        <input type="text" name="entreprise" value="Entreprise blabla" />
                        <label id="source">source</label>
                        <input type="text" name="source" value="Linkedin" />
                        <label id="poste">poste</label>
                        <input type="text" name="poste" value="Intégrateur front" />
                        <label id="duree">duree</label>
                        <input type="text" name="duree" value="2 mois" />
                        <label id="typecontact">typecontact</label>
                        <select name="typecontact" id="typecontact">
                            <option value="Email">Email</option>
                            <option value="Message sur site">Message sur site</option>
                            <option value="Téléphone">Téléphone</option>
                            <option value="Courrier">Courrier</option>
                        </select>
                        <label id="infocontact">infocontact</label>
                        <input type="text" name="infocontact" value="Jean Dupont,05 22 11 22 33" />
                        <label id="date1ercontact">date1ercontact</label>
                        <input type="text" name="date1ercontact" value="24/08/2021"/>
                        <label id="nbrelance">nbrelance</label>
                        <input type="text" name="nbrelance" value="0"/>
                        <label id="daterelance">daterelance</label>
                        <input type="text" name="daterelance" value=""/>
                        <label id="statut">Statut</label>
                        <input type="text" name="statut" value="En attente"/>
                        <label id="commentaires">commentaires</label>
                        <input type="text" name="commentaires" value="Lorem ipsum dolor sit" />
                        <label id="removed">removed</label>
                        <input type="text" name="removed" readOnly value="no" />
                    </div>
                    <button type="submit">SOUMETTRE LE FORMULAIRE COMPLET</button>





                    {/***************************************************************/}
                </form>



                <form name="submit-to-google-sheet1" className="formCreateNew" onSubmit={(event) => {
                    event.preventDefault();
                    const form = document.forms['submit-to-google-sheet1']
                    fetch(scriptURL, { method: 'POST', body: new FormData(form) })
                        .then(response => {
                            if (response.status !== 200) {
                            } else {
                            }
                            return
                        })
                        .catch(error => {
                            return
                        })
                }}>
                    <input type="text" name="modify" value="1"/>
                        <select name="statut" id="statut">
                            <option value="En Attente">En Attente</option>
                            <option value="À voir">À voir</option>
                            <option value="Accepté">Accepté</option>
                            <option value="Refusé">Refusé</option>
                        </select>
                        <button type="submit">SOUMETTRE LE CHANGEMENT DE STATUT</button>
                </form>
               



                <form name="submit-to-google-sheet2" className="formCreateNew" onSubmit={(event) => {
                    event.preventDefault();
                    const form = document.forms['submit-to-google-sheet2']
                    fetch(scriptURL, { method: 'POST', body: new FormData(form) })
                        .then(response => {
                            if (response.status !== 200) {
                            } else {
                            }
                            return
                        })
                        .catch(error => {
                            return
                        })
                }}>
                    <input type="text" name="modifydate" value="1"/>
                    <input type="text" name="daterelance" readOnly value="16/08/2021" />
                        <button type="submit">SOUMETTRE LE CHANGEMENT DE DATE</button>
                </form>



                <div>
                    <div>


                    </div>
                </div>
            </div>
        </>
    )
}
